import "./Gallery.module.css";
import Header from "@/reusable_sections/Header";
import BrowseAllFiles from "./sections/BrowseAllFiles";
import TheDiningExperience from "./sections/TheDiningExperience";
import ReadyForAFreshStart from "./sections/ReadyForAFreshStart";
import Footer from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <Header />
      <BrowseAllFiles />
      <TheDiningExperience />
      <ReadyForAFreshStart />
      <Footer />
    </div>;
}